/* eslint-disable no-unused-vars,prefer-const, func-names, no-console, no-eval, consistent-return, no-unused-vars, no-restricted-syntax, class-methods-use-this, strict */
import barba from "@barba/core";
import ScrollMagic from "scrollmagic";

class Barba {
	constructor() {
		// Define your plugin slug (or get it from a global variable / data attribute)
		const pluginSlugEs = '.com/ofertas-trabajo';
		const pluginSlugEn = '.com/en/job-offers';

		let links = document.querySelectorAll('a');
		// Check if the links have the plugin slug in their href attribute
		for (let i = 0; i < links.length; i += 1) {
			let href = links[i].getAttribute('href');
			if (href && (href.includes(pluginSlugEs) || href.includes(pluginSlugEn))) {
				//console.log('Barba.js initialization skipped due to plugin slug in link:', href);
				//return;
			}
		}
		
		// If the current pathname includes your plugin slug, skip Barba initialization.
		if (window.location.href.indexOf(pluginSlugEs) !== -1 || window.location.href.indexOf(pluginSlugEn) !== -1) {
			//console.log('Barba.js initialization skipped due to plugin slug in current URL:', window.location.href);
			return;
		}

		window.previouslyLoadedScripts = [];
		this.initBarba();
	}

	initBarba() {
		console.log('init barba.js');
		const htmlDocument = document.getElementsByTagName("html")[0];

		barba.init({
			debug: false,
			cacheIgnore: false,
			prefetchIgnore: false,
			timeout: 15000,
			transitions: [
				{
					name: "default",
					beforeLeave({ current, next, trigger }) {
						document.body.classList.add("u-mobile-block-scroll");
						document.documentElement.classList.add("barba-is-leaving");
					},
					leave({ current, next, trigger }) {
						const async = this.async();
						setTimeout(() => {
							async();
						}, 800);
					},
					beforeEnter({ current, next, trigger }) {
						htmlDocument.style.scrollBehavior = "auto";
						htmlDocument.scrollIntoView({
							block: "start",
							behavior: "auto",
						});
					},
					enter({ current, next, trigger }) {
						document.documentElement.classList.remove("barba-is-leaving");
						htmlDocument.style.scrollBehavior = "smooth";
						next.container.classList.toggle("barba-container--fadein");
						document.body.classList.remove("u-mobile-block-scroll"); // Remove scroll block
					},
				},
			],
			prevent: ({ el }) => {
				const ignoreClasses = ["ab-item", "another-class-here"]; // Additional (besides .js-barba-prevent) ignore links with these classes (ab-item is for wp admin toolbar links)
				if (/.pdf/.test(el.href.toLowerCase())) {
					return true;
				}
				if (el.classList && el.classList.contains("js-barba-prevent")) {
					return true;
				}
				if (el.dataset && el.dataset.lightbox) {
					return true;
				}

				if (/#cookies-config/.test(el.href.toLowerCase())) {
					return true;
				}

				for (let i = 0; i < ignoreClasses.length; i += 1) {
					if (el.classList.contains(ignoreClasses[i])) {
						return true;
					}
				}

				if (/ofertas-trabajo/.test(el.href.toLowerCase())) {
					//return true;
				}
				if (/en\/job-offers/.test(el.href.toLowerCase())) {
					//return true;
				}
			},
			requestError: (trigger, action, url, response) => {
				console.log("REQUEST ERROR"); // eslint-disable-line no-console
				console.log(url); // eslint-disable-line no-console
				console.log(response); // eslint-disable-line no-console
			},
		});

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			htmlDocument.style.scrollBehavior = "auto";
			htmlDocument.scrollIntoView({
				block: "start",
				behavior: "auto",
			});

			if (document.body.classList.contains("u-mobile-block-scroll")) {
				window.menuReset();
			}
		});

		// Global enter hook
		barba.hooks.enter(({ current, next, trigger }) => {
			window.requestAnimationFrame(() => {
				// Destroy ScrollMagic scenes
				for (const s of window.scenes) {
					s.destroy();
				}
				//console.log("DATA",current, next, trigger);
				this.jumpToAnchor();
				this.setAutoplay();
				this.setBodyClasses(next.container);
				this.setTranslationLinks(next.container);
				this.mobileMenu();
				this.updateCurrentHighlightedMenu(next.html, trigger);
				//console.log(current.url.href);
				const backButton = document.querySelector('#back-button');
				if(backButton){
					backButton.href = current.url.href;
				}
				// Modules
				window.modulesLoader.loadModules();

				// Animations
				setTimeout(() => {
					window.scrollMagicController = new ScrollMagic.Controller();
					window.setAnimationScenes(window.scrollMagicController);
				}, 300);

				// WP admin bar
				this.fixWpAdminBar();
			});
		});

		barba.hooks.after((data) => {
			this.getStylesAndScripts(data, () => {
				this.domReloadEvents();
			});
		});

		barba.hooks.afterLeave((data) => {
			this.reloadInlineScript(data);
		});
	}

	domReloadEvents() {
		window.document.dispatchEvent(
			new Event("DOMContentLoaded", {
				bubbles: true,
				cancelable: true,
			})
		);

		window.document.dispatchEvent(new Event("load"));
		this.domReloadEventsTriggered = true;
	}

	getStylesAndScripts(data, callback) {
		// Convert HTML Raw data to HTML Element in order to parser it.
		const response = data.next.html.replace(
			/(<\/?)body( .+?)?>/gi,
			"$1notbody$2>",
			data.next.html
		);
		const parser = new DOMParser();
		const res = parser.parseFromString(response, "text/html");

		// Identify and load scripts and styles for the next page.
		this.getMultiScripts(res, callback);
		this.getMultiStyles(res);
	}

	getMultiStyles(res) {
		const newImports = [];
		const stylesTags = res.querySelectorAll('link[rel^="stylesheet"]');
		Array.from(stylesTags).forEach((s, i) => {
			const href = s.getAttribute("href");
			if (href) {
				// if not already initialized add it
				if (window.initializedStyles.indexOf(href) === -1) {
					newImports.push(href);
				}
			}
		});
		const loadStyle = () => {
			if (newImports.length > 0) {
				const nextStyle = newImports.shift();
				const link = document.createElement("link");
				link.type = "text/css";
				link.rel = "stylesheet";
				link.onload = () => {
					loadStyle();
				};
				link.href = nextStyle;
				const headScript = document.querySelector("script");
				headScript.parentNode.insertBefore(link, headScript);
			}
		};

		loadStyle();
	}

	getMultiScripts(res, callback) {
		const newImports = [];
		const newEvaluations = [];
		const scriptTags = res.getElementsByTagName("script");

		Array.from(scriptTags).forEach((s, i) => {
			const src = s.getAttribute("src");
			if (src) {
				// If not already initialized add it
				if (
					window.initializedScripts.indexOf(src) === -1 &&
					window.previouslyLoadedScripts.indexOf(src) === -1
				) {
					newImports.push(src);
				}
			} else {
				const scriptsNotAllowed = ["__bs_script__"]; // Scripts ID to not be loaded.
				const mimesNotAllowed = ["application/ld+json", "text/x-jsrender"]; // Scripts MIME Type to not be added.
				const scriptType = s.getAttribute("type");
				const scriptId = s.getAttribute("id");

				if (
					scriptsNotAllowed.indexOf(scriptId) === -1 &&
					mimesNotAllowed.indexOf(scriptType) === -1
				) {
					newEvaluations.push(s.innerHTML);
				}
			}
		});

		function loadScript(url) {
			return new Promise(function (resolve, reject) {
				let script = document.createElement("script");
				script.type = "application/javascript";
				script.src = url;
				script.async = false;
				script.onload = function () {
					resolve(url);
				};
				script.onerror = function () {
					reject(url);
				};
				document.body.appendChild(script);
				window.previouslyLoadedScripts.push(url);
			});
		}

		// Save all Promises as array
		let promises = [];
		newImports.forEach(function (url) {
			promises.push(loadScript(url));
		});

		Promise.all(promises)
			.then(function () {
				// First eval load inline scripts.
				if (newEvaluations.length > 0) {
					newEvaluations.forEach((s) => {
						window.eval(`${s}`);
					});
				}
				callback();
			})
			.catch(function (script) {
				console.error(`${script} failed to load`);
			});
	}

	jumpToAnchor() {
		if (window.location.hash !== "") {
			if (document.readyState === "complete") {
				setTimeout(() => {
					this.jumpToAnchorDelayed();
				}, 100);
			} else {
				document.onreadystatechange = () => {
					if (document.readyState === "complete") {
						this.jumpToAnchor();
					}
				};
			}
		} else {
			window.scrollTo(0, 0);
		}
	}

	jumpToAnchorDelayed() {
		if (window.location.hash !== "") {
			let id = window.location.hash;

			if (id.indexOf("?") !== -1) {
				id = id.substr(0, id.indexOf("?"));
			}

			let scrollY = 0;
			let scrollTo = 0;
			if (document.querySelector(id)) {
				scrollY = Math.max(
					window.pageYOffset,
					document.documentElement.scrollTop,
					document.body.scrollTop
				);
				scrollTo =
					document.querySelector(id).getBoundingClientRect().top + scrollY;
			} else {
				console.log("ERROR: No existe el ID " + id); // eslint-disable-line
			}
			window.scrollTo(0, scrollTo);
		} else {
			window.scrollTo(0, 0);
		}
	}

	setAutoplay() {
		if (document.readyState === "complete") {
			setTimeout(() => {
				this.setAutoplayDelayed();
			}, 100);
		} else {
			document.onreadystatechange = () => {
				if (document.readyState === "complete") {
					this.setAutoplay();
				}
			};
		}
	}

	setAutoplayDelayed() {
		const video = document.getElementById("teaser");

		if (video) {
			video.play();
		}
	}

	setBodyClasses(e) {
		const skipClasses = [""]; // Add the classes you want to skip
		const currentBodyClasses = document.querySelector("body").classList;
		const newBodyClasses = e.querySelector("#body-classes").value;
		const splittedNewBodyClasses = newBodyClasses.split(" ");
		for (let i = 0; i < currentBodyClasses.length; i += 1) {
			if (newBodyClasses.indexOf(currentBodyClasses[i]) > -1) {
				skipClasses.push(currentBodyClasses[i]);
			}
		}
		Array.from(currentBodyClasses).forEach((bodyClass) => {
			// Don't remove class if it exists in skipClasses
			if (!skipClasses.includes(bodyClass)) {
				currentBodyClasses.remove(bodyClass);
			}
		});
		for (let s = 0; s < splittedNewBodyClasses.length; s += 1) {
			document.querySelector("body").classList.add(splittedNewBodyClasses[s]);
		}
	}

	reloadInlineScript(data) {
		const js = data.next.container.querySelectorAll("script.reload-on-ajax");
		[].forEach.call(js, function (script) {
			window.eval(script.innerHTML);
		});

		// Get Acton forms for events.
		const aoforms = data.next.container.querySelectorAll("script[id^=aoform]");
		const aoScriptUrl =
			"https://marketing.ayesa.com/acton/content/form_embed.js";

		if (aoforms.length > 0) {
			if (window.initializedScripts.includes(aoScriptUrl)) {
				[].forEach.call(aoforms, function (script) {
					window.eval(script.innerHTML);
				});
			} else {
				window.loadJS(aoScriptUrl, () => {
					window.initializedScripts.push(aoScriptUrl);
					[].forEach.call(aoforms, function (script) {
						window.eval(script.innerHTML);
					});
				});
			}
		}
	}

	setTranslationLinks(e) {
		"use strict";

		const linksData = e.getAttribute("data-translation-links");
		if (linksData) {
			const links = JSON.parse(linksData);
			//console.log(links);
			if (links.constructor === Array && links.length > 0) {
				for (let s = 0; s < links.length; s += 1) {
					const headerLi = document.querySelector(
						`.header-desktop__languages__new__selector .selector-lang a:nth-child( ${s + 1})`
					);
					if (headerLi !== null) {
						headerLi.setAttribute("href", links[s]);
					}

					const headerLiMobile = document.querySelector(
						`.header-mobile__languages__new .selector-lang a:nth-child( ${s + 1})`
					);
					if (headerLiMobile !== null) {
						headerLiMobile.setAttribute("href", links[s]);
					}

					const footerLi = document.querySelector(
						`.footer__languages a:nth-child( ${s + 1})`
					);
					if (footerLi !== null) {
						footerLi.setAttribute("href", links[s]);
					}
				}
			}
		}
	}

	mobileMenu() {
		const mobileMenuToogler = document.getElementById("main-menu-toggler");
		if (mobileMenuToogler) {
			mobileMenuToogler.checked = false;
		}
	}

	/**
	 * Parses the DOM structure of the BarbaJS fetch, and applies same classes on the header in DOM.
	 * @param {String} htmlString - The new page html in string format from barbaJs
	 */
	updateCurrentHighlightedMenu(htmlString, trigger) {
		window.updateHighlightMenu();
		return;
		/*
		console.log(trigger);
		const html = new window.DOMParser().parseFromString(
			htmlString,
			"text/html"
		);
		if ("body" in html === false || html.body.childNodes.length < 1) {
			// Why the length check?
			return;
		}
		// First remove current classes from all menu items and sub menus.
		for (const el of Array.from(document.querySelectorAll(".menu-item, .current-menu-item"))) {
			//console.log('prueba delete');
			el.classList.remove("current-menu-item");
			//el.classList.remove("current-menu-parent");
			//el.classList.remove("current-menu-ancestor");
		}
		// Get the new current menu items and parents and set the appropiate classes.
		let newEl;
		if (trigger && trigger.classList) {
			trigger.classList.add("current-menu-item");	
		}
		let id_parent = trigger.getAttribute("data-id-parent");
		let parent = document.querySelector(`#menu-item-${id_parent}`);
		if(parent){
			parent.classList.add("current-menu-item");
			id_parent = parent.getAttribute("data-id-parent");
			parent = document.querySelector(`#menu-item-${id_parent}`);
			if(parent){
				parent.classList.add("current-menu-item");
			}
		}
		id_parent = trigger.getAttribute("data-id-parent");
		parent = document.querySelector(`#menu-item-resp-${id_parent}`);
		if(parent){
			parent.classList.add("current-menu-item");
			id_parent = parent.getAttribute("data-id-parent");
			parent = document.querySelector(`#menu-item-resp-${id_parent}`);
			if(parent){
				parent.classList.add("current-menu-item");
			}
		}
		
		//for (const el of Array.from(html.querySelectorAll(".current-menu-item"))) {
		//	console.log('prueba fuera add', el);
		//	console.log('prueba fuera add', el.id);
		//	if (el.id) {
		//		newEl = document.querySelector(`#${el.id}`);
		//		console.log('prueba add', newEl);
		//		if (newEl !== null) {
		//			//console.log(el.id);
		//			newEl.classList.add("current-menu-item");
		//			//newEl.querySelector('a').classList.add("current-menu-item");
		//		}
		//	}
		//}
		
		/*

		for (const el of Array.from(
			html.querySelectorAll(".current-menu-parent")
		)) {
			if (el.id) {
				newEl = document.querySelector(`#${el.id}`);
				if (newEl !== null) {
					newEl.classList.add("current-menu-parent");
				}
			}
		}
		for (const el of Array.from(
			html.querySelectorAll(".current-menu-ancestor")
		)) {
			if (el.id) {
				newEl = document.querySelector(`#${el.id}`);
				if (newEl !== null) {
					newEl.classList.add("current-menu-ancestor");
				}
			}
		}
		
		*/
	}

	fixWpAdminBar() {
		if (!document.querySelector("#wpadminbar")) {
			return;
		}

		const xmlhttp = ajaxReq(); // eslint-disable-line
		const url = encodeURI(scriptsAjaxVariables.ajax_url); // eslint-disable-line
		const params = `action=aye_fix_barbajs_wp_admin&location=${window.location.href}`;

		xmlhttp.open("POST", url, true); // set true for async, false for sync request
		xmlhttp.setRequestHeader(
			"Content-type",
			"application/x-www-form-urlencoded"
		);
		xmlhttp.send(params); // or null, if no parameters are passed
		xmlhttp.onreadystatechange = () => {
			if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
				try {
					const response = JSON.parse(xmlhttp.responseText);
					if (response && response.success === true) {
						const adminMenuLinks = Array.from(
							document.querySelector(".ab-top-menu").querySelectorAll("a")
						);
						for (const adminLink of adminMenuLinks) {
							const mregex = /post=(\d+)&/g;
							adminLink.classList.add("js-barba-prevent");
							const href = adminLink.getAttribute("href");
							const groups = mregex.exec(href);
							if (groups && groups.length >= 2) {
								adminLink.setAttribute(
									"href",
									href.replace(groups[1], response.pageId)
								);
							} else {
								const chunks = href.split("?url=");
								const encodedWindowLocationHref = encodeURIComponent(
									window.location.href
								);
								if (chunks.length === 2) {
									adminLink.setAttribute(
										"href",
										`${chunks[0]}?url=${encodedWindowLocationHref}`
									);
								}
							}
						}
					}
				} catch (error) {
					console.log(error);
				}
			}
		};
	}
}

export default Barba;
